import { useSelector } from "react-redux";
import LicenciaCardComponent from "../licenciaCard/licenciaCard";
import LicenciaCardSkeleton from "./licenciaCardSkeleton";

function LicenciasCardsComponent({
  loading,
  error,
  onLicenciaActualizada,
}) {
  const licencias = useSelector(
    (state) => state.licencias
  );

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 mid:grid-cols-3 custom:grid-cols-2 gap-4 p-4">
        {loading ? (
          Array.from({ length: 9 }).map((_, index) => (
            <LicenciaCardSkeleton key={index} />
          ))
        ) : error ? (
          <div className="col-span-full flex flex-col items-center justify-center py-16 text-center">
            <h2 className="text-lg font-semibold text-gray-700">
              No se pudieron cargar las licencias
            </h2>

            <p className="mt-2 text-sm text-gray-500">
              Ocurrió un problema al comunicarse con el servidor.
            </p>
          </div>
        ) : (
          licencias.map(
            ({
              id,
              dni,
              nombre,
              fecha_hora,
              egresada,
              observaciones,
              tipo,
              foto,
            }) => (
              <LicenciaCardComponent
                key={id}
                dni={dni}
                nombre={nombre}
                egresada={egresada}
                observaciones={observaciones}
                tipo={tipo}
                fecha_hora={fecha_hora}
                foto={foto}
                id={id}
                onLicenciaActualizada={
                  onLicenciaActualizada
                }
              />
            )
          )
        )}
      </div>
    </div>
  );
}

export default LicenciasCardsComponent;